import script from "./LogsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./LogsTable.vue?vue&type=script&setup=true&lang=js"

import "./LogsTable.vue?vue&type=style&index=0&id=66e92334&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66e92334"]])

export default __exports__